import React from 'react';
import { Box, Paper, TextField, Typography, Button } from '@mui/material';

const Contact: React.FC = () => {
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [sending, setSending] = React.useState(false);
  // Honeypot state: real users never see/use this
  const [website, setWebsite] = React.useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!message.trim()) { setError('Please enter a message.'); return; }
    try {
      setSending(true);
      // Honeypot field: bots often fill this hidden input. Backend will drop when set.
      const payload: any = { name: name || null, email: email || null, subject: null, message: message.trim(), website: '' };
      const { apiService } = await import('../services/apiService');
      // Note: default export is an instance; here we import the module to reuse the singleton
      await apiService.postSupportMessage(payload);
      setSubmitted(true);
      setName(''); setEmail(''); setMessage('');
    } catch (e: any) {
      setError(e?.response?.data?.detail || 'Failed to send. Please try again later.');
    } finally {
      setSending(false);
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Contact Us</Typography>
      <Typography variant="body1" paragraph>
        Have feedback, questions, or suggestions? Send us a message. We read every note and use your input to improve AskTheBill.ai.
      </Typography>
      {!submitted ? (
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'grid', gap: 2, maxWidth: 600 }}>
          <TextField label="Name" value={name} onChange={(e) => setName(e.target.value)} fullWidth />
          <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth />
          {/* Honeypot input: hidden from users; bots may fill it. */}
          <input
            type="text"
            name="website"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
            autoComplete="off"
            style={{ position: 'absolute', left: '-5000px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden' }}
            aria-hidden="true"
            tabIndex={-1}
          />
          <TextField label="Message" value={message} onChange={(e) => setMessage(e.target.value)} fullWidth multiline minRows={4} />
          {error && <Typography variant="body2" color="error">{error}</Typography>}
          <Button type="submit" variant="contained" disabled={sending || !message.trim()}>{sending ? 'Sending…' : 'Send'}</Button>
          <Typography variant="caption" color="text.secondary">
            Your message will be saved securely. Our team reviews all submissions.
          </Typography>
        </Box>
      ) : (
        <Typography variant="body1" color="success.main">Thanks! Your message has been noted.</Typography>
      )}
    </Paper>
  );
};

export default Contact;
